import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useAuth as useClerkAuth } from '@clerk/clerk-react';
import { isNative } from './native';
import { initNativePush, clearDeliveredNotifications } from './push';
import { attachAppLifecycle } from './appLifecycle';
import { MOBILE_HOME_PATH } from './mobileScope';
import { parseChatUserIdFromPathname } from 'utils/chat-path-params';

/**
 * מחובר ב-MainLayout (בתוך ה-router, אחרי התחברות): רישום push, ניווט מהתראה,
 * כפתור Back של אנדרואיד וחזרה מרקע. בווב לא עושה כלום.
 */
export default function NativeBootstrap() {
  const navigate = useNavigate();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const { isSignedIn } = useClerkAuth();

  const locationRef = React.useRef(location);
  locationRef.current = location;

  React.useEffect(() => {
    if (!isNative || !isSignedIn) return;

    void initNativePush({
      onTap: (data) => {
        const phone = data.phone;
        navigate(phone ? `${MOBILE_HOME_PATH}/${phone}` : MOBILE_HOME_PATH);
      },
      onForeground: (notification) => {
        const phone = (notification.data as Record<string, string> | undefined)?.phone;
        const currentChat = parseChatUserIdFromPathname(locationRef.current.pathname);
        if (phone && currentChat === phone) return; // המשתמש כבר בשיחה — message:new יציג את ההודעה
        const text = [notification.title, notification.body].filter(Boolean).join(': ');
        enqueueSnackbar(text || 'הודעה חדשה', {
          variant: 'info',
          autoHideDuration: 4000,
          onClick: phone ? () => navigate(`${MOBILE_HOME_PATH}/${phone}`) : undefined,
        } as never);
      },
    });
  }, [isSignedIn, navigate, enqueueSnackbar]);

  React.useEffect(() => {
    if (!isNative) return undefined;
    return attachAppLifecycle({
      onBack: () => {
        const { pathname } = locationRef.current;
        if (parseChatUserIdFromPathname(pathname)) {
          navigate(MOBILE_HOME_PATH);
          return true;
        }
        if (pathname === MOBILE_HOME_PATH || pathname === `${MOBILE_HOME_PATH}/`) {
          return false; // ברשימת השיחות — Back יוצא מהאפליקציה
        }
        navigate(MOBILE_HOME_PATH);
        return true;
      },
    });
  }, [navigate]);

  React.useEffect(() => {
    if (!isNative) return;
    if (parseChatUserIdFromPathname(location.pathname)) void clearDeliveredNotifications();
  }, [location.pathname]);

  return null;
}
